import React, { createContext, useState } from "react";
import useAxios from "../api/useAxios";

import { useSearchParams } from "react-router-dom";

const ReturnsContext = createContext();

export default ReturnsContext;
export const ReturnsProvider = ({ children }) => {
  const [searchParams, setSearchParams] = useSearchParams(
    {},
    { replace: true }
  );

  let [page, setPage] = useState(1);
  let [limit, setLimit] = useState(50);
  let [totalItems, setTotalItem] = useState(null);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [isConfirmModal, toggleConfirmModal] = useState(false);

  let api = useAxios();

  let fetchData = async () => {
    const params = Object.fromEntries([...searchParams]);
    let response = await api.get(`/manager/order_return`, {
      params,
    });

    if (response.status === 200) {
      setTotalItem(response.data.totalItems);
      return response.data;
    }
  };

  let contextReturnsData = {
    page: page,
    setPage: setPage,
    limit: limit,
    setLimit: setLimit,
    fetchData: fetchData,
    totalItems: totalItems,

    searchParams: searchParams,
    setSearchParams: setSearchParams,
  };

  return (
    <ReturnsContext.Provider value={contextReturnsData}>
      {children}
    </ReturnsContext.Provider>
  );
};
